import { useState } from 'react';

/**
 * Liga uma acao ao fluxo de assinatura.
 *
 * Nao verifica nada de antemao: executa a acao e, se o servidor responder
 * STEP_UP_REQUIRED, guarda a acao para repetir depois da confirmacao. Assim a
 * regra de quando exigir assinatura vive so no servidor — o cliente nao tem
 * uma segunda copia dela para divergir.
 */
export default function useSignature() {
  const [pending, setPending] = useState(null);

  async function run(action, prompt) {
    try {
      await action();
      return true;
    } catch (err) {
      if (err.response?.data?.code === 'STEP_UP_REQUIRED') {
        setPending({ action, ...prompt });
        return false;
      }
      throw err;
    }
  }

  async function confirmed() {
    const current = pending;
    setPending(null);
    if (current) await current.action();
  }

  return { pending, run, confirmed, cancel: () => setPending(null) };
}
